import React, {useState} from "react";
import {Alert, Button, Grid, Paper, Typography} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../store/reducers";
import {MultiSelectElement, SelectElement} from "react-hook-form-mui";
import format from "date-fns/format";
import {isValid, parseISO} from "date-fns";
import {postAddMatriculaDisciplinas} from "../../store/actions/alunosActions";
import {useForm} from "react-hook-form";
import {useSnackbar} from "notistack";

interface iAlunoAddDOffSelector  {
    levelId: number | undefined,
}


const AlunoAddDOffSelector = ( props: iAlunoAddDOffSelector ) => {
    const levelId = (typeof(props.levelId) !== "undefined")? props.levelId : 0;

    const aluno = useSelector((state: RootState) => state.cadastros.aluno);
    const dofAbertas = useSelector((state: RootState) => state.cadastros.dofAbertas);
    const { enqueueSnackbar } = useSnackbar();

    const [dataEnrollment, setDataEnrollment] = useState<any[]>([]);
    const [dataClasses, setDataClasses] = useState<any[]>([]);
    const [dataDiscOfertas, setDataDiscOfertas] = useState<any[]>([]);
    const [alertMsg, setAlertMsg] = useState<string | null>(null);


    const { control, handleSubmit, reset, setValue, getValues}
        = useForm({
        defaultValues: {
            enrollment: 0,
            classe: 0,
            matricularEm: [],
        }
    });



    const dispatch = useDispatch();

    React.useEffect(() => {
        getMatriculas();
        getClasses();

        }, []);



    const getMatriculas = () => {
        const data: any[] = [];
        aluno.enrollmentInLevel
            .filter( (eil: any) => eil.level.id === levelId)
            .forEach( (eil: any) => {
            eil.enrollment.forEach( (enrollment: any) => {
                data.push({id: enrollment.id, label: `${eil.level.Description} - Matricula: ${enrollment.id} - Carne: ${enrollment.PaymentCard}`});
            });
        });
        setDataEnrollment(data);
    }

    /** Find the full enrollment object by id from the aluno tree */
    const findEnrollment = (enrollmentId: number): any | null => {
        for (const eil of (aluno.enrollmentInLevel || [])) {
            for (const e of (eil.enrollment || [])) {
                if (e.id === enrollmentId) return e;
            }
        }
        return null;
    };

    const getClasses = () => {
        const data: any[] = [];
        dofAbertas
            .filter( (d: any) => d.disciplineModule.discipline.Level_id === levelId)
            .filter( (d: any) => parseISO(d.EndDate) > new Date())
            .forEach( (d: any) => {
                 if (data.findIndex( (d2: any) => d2.id === d.ClassOffer_id) < 0)
                {
                    data.push({
                        id: d.ClassOffer_id,
                        label: `${d.ClassOffer_id} - ${d.period.Description}  ${d.classOffer.Description} ${d.classOffer.Room} ${d.classOffer.Shift} ${ (isValid(parseISO(d.classOffer.InitialDate)))? format(parseISO(d.classOffer.InitialDate), "dd/MM/yyyy") : 'X'} -> ${isValid(parseISO(d.EndDate))? format(parseISO(d.EndDate), "dd/MM/yyyy") : 'F'}`
                    });
                }
        });
        setDataClasses(data);
    }

    const getDiscOfertas = (c : number) => {
        const data: any[] = [];
        dofAbertas
            .filter( (d: any) => d.ClassOffer_id === c)
            .filter( (d: any) => parseISO(d.EndDate) > new Date())
            .sort( (a: any, b: any) => a.InitialDate.localeCompare(b.InitialDate))
            .forEach( (d: any) => {
                data.push({
                    id: d.id,
                    labelSmall: `${d.id} - ${d.disciplineModule.discipline.Description} - ${d.disciplineModule.Description} `,
                    label: `${d.id} - ${ (d.disciplineModule.discipline.Description +' '+d.disciplineModule.Description).padEnd(35,'\xa0')}  - ${isValid(parseISO(d.InitialDate))? format(parseISO(d.InitialDate), "dd/MM/yyyy") : ''} -> ${isValid(parseISO(d.EndDate))? format(parseISO(d.EndDate), "dd/MM/yyyy") : 'F'}`
                });
            });
        setDataDiscOfertas(data);

    }

    const onSubmit = (data: any) => {
        setAlertMsg(null);

        // Find the selected enrollment
        const enrollment = findEnrollment(data.enrollment);
        if (!enrollment) {
            enqueueSnackbar('Selecione uma matrícula', { variant: 'warning' });
            return;
        }

        // Validate dhDate and dhExpireDate
        const dhDate = enrollment.dhDate ? parseISO(enrollment.dhDate) : null;
        const dhExpireDate = enrollment.dhExpireDate ? parseISO(enrollment.dhExpireDate) : null;

        const warnings: string[] = [];

        if (!dhDate || !isValid(dhDate) || !dhExpireDate || !isValid(dhExpireDate)) {
            const missing: string[] = [];
            if (!dhDate || !isValid(dhDate)) missing.push('Data de Matrícula');
            if (!dhExpireDate || !isValid(dhExpireDate)) missing.push('Data de Expiração');
            warnings.push(`ATENÇÃO: A matrícula #${enrollment.id} não possui ${missing.join(' e ')}.`);
        }

        // Validate discipline periods vs expiration date
        const selectedDofs: number[] = data.matricularEm || [];
        if (selectedDofs.length === 0) {
            enqueueSnackbar('Selecione ao menos uma disciplina', { variant: 'warning' });
            return;
        }

        if (dhExpireDate && isValid(dhExpireDate)) {
            const posteriors: string[] = [];
            for (const dofId of selectedDofs) {
                const dof = dofAbertas.find((d: any) => d.id === dofId);
                if (dof && dof.EndDate) {
                    const dofEnd = parseISO(dof.EndDate);
                    if (isValid(dofEnd) && dofEnd > dhExpireDate) {
                        const discName = dof.disciplineModule?.discipline?.Description || `DOF#${dofId}`;
                        const modName = dof.disciplineModule?.Description || '';
                        posteriors.push(`${discName} ${modName} (fim: ${format(dofEnd, 'dd/MM/yyyy')})`);
                    }
                }
            }
            if (posteriors.length > 0) {
                warnings.push(`ATENÇÃO: Período posterior à expiração da matrícula (${format(dhExpireDate, 'dd/MM/yyyy')}): ${posteriors.join(', ')}`);
            }
        }

        if (warnings.length > 0) {
            setAlertMsg(warnings.join('\n'));
        }

        dispatch(postAddMatriculaDisciplinas(aluno.id, data.enrollment, data.matricularEm));
        setValue('matricularEm', []);
    }

    return (<React.Fragment>
        <form
           onSubmit={handleSubmit((data: any) => {
               onSubmit(data);
            })}
        >
                <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
                    <Typography variant="subtitle2" color="primary" sx={{ mb: 1 }}>ADICIONAR DISCIPLINAS</Typography>

                    {alertMsg && (
                        <Alert severity="warning" sx={{ mb: 1.5 }} onClose={() => setAlertMsg(null)}>
                            {alertMsg}
                        </Alert>
                    )}

                    <Grid container spacing={1}>
                        {/* Linha 1: Nivel + Classe */}
                        <Grid item xs={12} md={6}>
                            <SelectElement
                                control={control}
                                label="Nivel"
                                name="enrollment"
                                defaultValue={''}
                                options={dataEnrollment}
                                fullWidth
                                onChange={(e: any) => {
                                    setValue('enrollment', e);
                                    setAlertMsg(null);
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <SelectElement
                                control={control}
                                label="Classe"
                                name="classe"
                                defaultValue={''}
                                options={dataClasses}
                                fullWidth
                                onChange={(e: any) => {
                                    setValue('classe', e);
                                    getDiscOfertas(e);
                                    setAlertMsg(null);
                                }}
                            />
                        </Grid>
                        {/* Linha 2: Disciplinas + Botao */}
                        <Grid item xs={12} md={10}>
                            <MultiSelectElement
                                control={control}
                                label="Disciplinas"
                                name="matricularEm"
                                defaultValue={''}
                                options={dataDiscOfertas}
                                showChips={true}
                                itemLabel="label"
                            />
                        </Grid>
                        <Grid item xs={12} md={2} sx={{ display: 'flex', alignItems: 'center' }}>
                            <Button type={"submit"} variant="contained" size="small" startIcon={<AddIcon />} fullWidth>
                                ADICIONAR
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
        </form>
    </React.Fragment>);
}
export default (AlunoAddDOffSelector);
